import { BASE_ENDPOINT } from '../endpoints'

const main = `${BASE_ENDPOINT}/api/v1/`
export const searchRfcEndpoint = `${main}black-lists/sat/search`
export const csvSearchRfcEndpoint = (accountRfcID) => `${main}account-rfc/${accountRfcID}/black-lists/sat/csv-search`
export const rfcMonitoringEndpoint = `${main}black-lists/monitoring/override-list`

export function rfcMonitoringSearchEndpoint(accountRfcID) {
  return `${main}black-lists/monitoring/${accountRfcID}/search`
}

export function rfcMonitoringListEndpoint(accountRfcID) {
  return `${main}black-lists/monitoring/${accountRfcID}`
}

export function accountRfcRateStateEndpoint(accountRfcRateStateID) {
  return `${main}accounts/rfcs/rate-state/${accountRfcRateStateID}`
}


export const monitoringListItemsEndpoint = (accountRfcID) => `${main}black-lists/monitoring/${accountRfcID}`

export const downloadBlackListCSVEndpoint = `${main}black-lists/sat/download`

export const limitRFCUniqueBlackList = `${main}account-rfc/limitRFCUnique/black-list`
export const substractLimitRFC = `${main}black-lists/sat/substract`
